<template>
<div>
        <div class="form-group row">

                <div class="col-lg-8">
            
                    <DropFiles   DropFiles :file="validate_file(item.screen_video1)" 
                                    :module_id="item._id?item._id:this.moduleId"
                                    @onUploaded="updateScreen_video1" 
                                    @onRemoved="removeScreen_video1"
                                    :accept="'video/mp4'"
                                    module_type="events" 
                                    asset_type="exhibition_hall_background_image"  
                                    @onError="errCb">

                        <template #header>
                            <label>Video Screen 1 (Should be in MP4 format)</label>
                        </template>
                        <template #tooltip>
                            <VTooltip style="display:inline-block">
                            <i class="fa fa-info-circle" style="font-size:16px"></i>
                            <template #popper>
                                <img src="/admin_assets/img/event_garden_smallbanner_5.png"/>
                            </template>
                            </VTooltip>
                        </template>
                        </DropFiles>

                </div>
       </div>
       <div class="form-group row">
     
            <div class="col-lg-8">
        
                <DropFiles   DropFiles :file="validate_file(item.screen_video2)" 
                         :module_id="item._id?item._id:this.moduleId"
                        @onUploaded="updateScreen_video2" 
                        @onRemoved="removeScreen_video2"
                        :accept="'video/mp4'"
                        module_type="events" 
                        asset_type="exhibition_hall_background_image"  
                        @onError="errCb">

            <template #header>
                <label>Video Screen 2 (Should be in MP4 format)</label>
            </template>
            <template #tooltip>
                <VTooltip style="display:inline-block">
                <i class="fa fa-info-circle" style="font-size:16px"></i>
                <template #popper>
                    <img src="/admin_assets/img/event_garden_smallbanner_5.png"/>
                </template>
                </VTooltip>
            </template>
            </DropFiles>

            </div>
        </div>
    <div class="form-group row">
        
            <div class="col-lg-8">

            
        <DropFiles   DropFiles :file="validate_file(item.screen_document1)" 
                         :module_id="item._id?item._id:this.moduleId"
                        @onUploaded="updateScreen_document1" 
                        @onRemoved="removeScreen_document1"
                        :accept="'application/pdf'"
                        module_type="events" 
                        asset_type="exhibition_hall_background_image"  
                        @onError="errCb">

            <template #header>
                <label>Document Screen 1 (Should be in PDF format)</label>
            </template>
            <template #tooltip>
                <VTooltip style="display:inline-block">
                <i class="fa fa-info-circle" style="font-size:16px"></i>
                <template #popper>
                    <img src="/admin_assets/img/event_garden_smallbanner_5.png"/>
                </template>
                </VTooltip>
            </template>
            </DropFiles>

            </div>
    </div>


    <div class="form-group row">
        
        <div class="col-lg-8">

        
    <DropFiles   DropFiles :file="validate_file(item.screen_document2)" 
                     :module_id="item._id?item._id:this.moduleId"
                    @onUploaded="updateScreen_document2" 
                    @onRemoved="removeScreen_document2"
                    :accept="'application/pdf'"
                    module_type="events" 
                    asset_type="exhibition_hall_background_image"  
                    @onError="errCb">

        <template #header>
            <label>Document Screen 2 (Should be in PDF format)</label>
        </template>
        <template #tooltip>
            <VTooltip style="display:inline-block">
            <i class="fa fa-info-circle" style="font-size:16px"></i>
            <template #popper>
                <img src="/admin_assets/img/event_garden_smallbanner_5.png"/>
            </template>
            </VTooltip>
        </template>
        </DropFiles>

        </div>
    </div>

    <div class="form-group row">
    
        <div class="col-lg-4">
            <label>Screen 1 Description (Maximum 255 characters)</label>
            <div class="kt-input-icon">
                <input
                  type="text"
                  class="form-control"
                  name="screen_1_description"
                  placeholder="Screen 1 description"
                  :value="item.screen_1_description"
                  @input="updateScreenDesc1"
                  max="50"
                />
            </div>
        </div>
        <div class="col-lg-4">
            <label>Screen 2 Description (Maximum 255 characters)</label>
            <div class="kt-input-icon">
                <input
                  type="text"
                  class="form-control"
                  name="screen_2_description"
                  placeholder="Screen 2 description"
                  :value="item.screen_2_description"
                  @input="updateScreenDesc2"
                  max="50"
                />
            </div>
        </div>
    </div>

    
</div>
<FlashMessage group="exhibition_area_video" />
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import _ from 'lodash';
import  configsize  from "@/config/configsize";
  //.EXHIBITION_AREA_PDF_SIZE ,EXHIBITION_AREA_VIDEO_SIZE
import ObjectID from 'bson-objectid';

export default {
    name: "VideoScreensTab",
    data() {
        return {
            pdfSize     : configsize.EXHIBITION_AREA_PDF_SIZE,
            videoSize   : configsize.EXHIBITION_AREA_VIDEO_SIZE,
            moduleId    : ObjectID(),

        }
       
    },
    beforeUnmount() {
      this.resetState();
      delete this.$flashMessage.groups.exhibition_area_video;
    },
    created() {
      this.fetchEventData(this.$route.params.event_id);
      this.fetchConfiguration();
     },
    computed: {
        ...mapGetters("ExhibitionAreasSingle", [
            "item",
            "loading",
            "event_type",
            "skyboxes",
            "environments"
        ]),
        ...mapGetters("EventsSingle", {"eventItem": "item"}),
        ...mapGetters('ConfigurationsSingle', {'projectConfiguration':'item'})
    },
    methods: {
        ...mapActions('ConfigurationsSingle', {'fetchConfiguration': 'fetchData'}),   
        ...mapActions("EventsSingle",{"fetchEventData":"fetchData"}),
        ...mapActions("ExhibitionAreasSingle", [
            "setScreen_video1",
            "setScreen_video2",
            "setScreen_document1",
            "setScreen_document2",
            "setScreenDesc1",
            "setScreenDesc2",
            "resetState"
        ]),
        validate_file(fileInfo) {
            if (_.has(fileInfo, 'key'))
                return fileInfo;
            return null;
        },
        updateScreenDesc1(e) {
            this.setScreenDesc1(e.target.value);
        },
        updateScreenDesc2(e) {
            this.setScreenDesc2(e.target.value);
        },

        updateScreen_video1(info,data) {
            const key = _.get(this.item.video_screen1, 'key', null);
            const size = _.get(info, 'file.size', 0);
            let fileKey = data.data.key?data.data.key:data.data.Key; 
            const extension = fileKey.split('.').pop();
            if(size>this.videoSize){
                this.showVideoError();
                return;
            }     
            this.setScreen_video1({
                old_key: key,
                key: fileKey,
                temp_key: info.id,
                size: size.toString(),
                extension: extension,
                uploadedBy:  info.user.first_name + ' ' + info.user.last_name,
                uploadedAt: '2023.01.01',
            });
        },
        updateScreen_video2(info , data) {
            const key = _.get(this.item.video_screen2, 'key', null);
            const size = _.get(info, 'file.size', 0);
            let fileKey = data.data.key?data.data.key:data.data.Key; 
            const extension = fileKey.split('.').pop();
            if(size>this.videoSize){
                this.showVideoError();
                return;
            }
            this.setScreen_video2({
                old_key: key,
                key: fileKey,
                temp_key: info.id,
                size: size.toString(),
                extension: extension,
                uploadedBy:  info.user.first_name + ' ' + info.user.last_name,
                uploadedAt: '2023.01.01',
            });
        },
        removeScreen_video1(e) {
            this.setScreen_video1(null);
        },
        removeScreen_video2(e) {
            this.setScreen_video2(null);
        },

        removeScreen_document1(e) {
            this.setScreen_document1(null);
               
        },
        removeScreen_document2(e) {
            this.setScreen_document2(null);
        },
  
        updateScreen_document1(info, data) {
            
            const key = _.get(this.item.document_screen1, 'key', null);
            let fileKey = data.data.key?data.data.key:data.data.Key; 
            const extension = fileKey.split('.').pop();
          
            const size = _.get(info, 'file.size', 0);
            console.log('size', size,"this.pdfSize",this.pdfSize);
            if(size>this.pdfSize){
                this.showCbError();
                return;
            }
            this.setScreen_document1({
                old_key: key,
                key: fileKey,
                temp_key: info.id,
                size: size.toString(),
                extension: extension,
                uploadedBy:  info.user.first_name + ' ' + info.user.last_name,
                uploadedAt: '2023.01.01',
            });
        },
        updateScreen_document2(info ,data) {
            
            const key = _.get(this.item.document_screen2, 'key', null);
            let fileKey = data.data.key?data.data.key:data.data.Key; 
            const extension = fileKey.split('.').pop();
          
            const size = _.get(info, 'file.size', 0);
            if(size>this.pdfSize){
                this.showCbError();
                return;
            }
            this.setScreen_document2({
                old_key: key,
                key: fileKey,
                temp_key: info.id,
                size: size.toString(),
                extension: extension,
                uploadedBy:  info.user.first_name + ' ' + info.user.last_name,
                uploadedAt: '2023.01.01',
            });
            
        },
        errCb(e){
            this.$flashMessage.show({
                group : 'exhibition_area_video',
                type  : 'error',
                title : 'Failed',
                html  : "<ul><li>Invalid File/Doc format.Please use described valid format</li></ul>"

            })
        },
        showCbError(e){
            this.$flashMessage.show({
                group : 'exhibition_area_video',
                type  : 'error',
                title : 'Failed',
                html  : "<ul><li>Uploaded document should be less than 30 MB.</li></ul>"

            })
        },
        showVideoError(e){
            this.$flashMessage.show({
                group : 'exhibition_area_video',
                type  : 'error',
                title : 'Failed',
                html  : "<ul><li>Uploaded video should be less than 500 MB.</li></ul>"

            })
        },
        getFileSizeConfigurationDocument(){
            if(this.eventItem.max_document_size && this.eventItem.max_document_size>0){
                return this.eventItem.max_document_size
            }
            return this.projectConfiguration.max_document_size
        },
        getFileSizeConfigurationVideo(){
            if(this.eventItem.max_video_size && this.eventItem.max_video_size>0){
                return this.eventItem.max_video_size
            }
            return this.projectConfiguration.max_video_size
        }
       
    }
}
</script>

<style scoped>

</style>